<template>
  <!-- PDF Content Here -->
  <div>
    <div class="row">
      <div class="col-6 pl-3 p-2">
        <span class="brand-logo"><b-img :src="appLogoImage" alt="logo" /></span>
      </div>
      <div class="col-6 text-right">
        INTERNATIONAL LOGISTICS CORPORATION<br />
        5th Fl, Saigon Port Building<br />
        No.3 Nguyen Tat Thanh St, Ward 13, Dist 4, HCMC, Vietnam <br />
        Tel: 08 394 35 899 - Fax: 08 394 35 898<br />
      </div>
    </div>
    <div class="row">
      <div class="col-6 pl-3 p-2">
        <div class="pl-4">
          Name: {{ quotation.customer_name }} <br />
          Company: {{ quotation.customer_company_name }}<br />
          Address: {{ quotation.customer_company_address }} <br />
          Phone : {{ quotation.customer_phone }}<br />
          Email: {{ quotation.customer_email }} <br />
        </div>
      </div>
      <div class="col-6 pl-3 p-2">
        <div class="pl-4">
          <div>Sales WR1: {{ quotation.sale_name }} <br /></div>
          <div>Phone: {{ quotation.sale_phone }}</div>

          <div>Email: {{ quotation.sale_email }}</div>
          <div>Booking No: {{ quotation.id }}</div>
          <div>Issue Date: {{ moment(new Date()).format("DD/MM/YYYY") }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center"><h2>DEBIT NOTE</h2></div>
    </div>
    <div class="row">
      <div class="col-6 pl-3 p-2">
        <div class="pl-4">
          POL: 
          {{
            request_quotation.pol
             
          }}

          <br />
         
          Shipper :
          {{
            quotation.shipment_on_fast
              ? quotation.shipment_on_fast.shipper_name
              : ""
          }}<br />
          Vessel/Voy:
          {{
            quotation.shipment_on_fast ? quotation.shipment_on_fast.vessel : ""
          }}
          {{
            quotation.shipment_on_fast ? quotation.shipment_on_fast.voyage : ""
          }}
          <br />
        </div>
      </div>
      <div class="col-6 pl-3 p-2">
        <div class="pl-4">
          <div>
            ETD&ETA:
            {{
              quotation.shipment_on_fast
                ? moment(new Date(quotation.shipment_on_fast.etd)).format(
                    "DD/MM/YYYY"
                  )
                : ""
            }}

            {{
              quotation.shipment_on_fast
                ? "& " +
                  moment(new Date(quotation.shipment_on_fast.eta)).format(
                    "DD/MM/YYYY"
                  )
                : ""
            }}<br />
          </div>
          <div>
            POD:
            {{
              request_quotation.pod
              
            }}

            <br />
          </div>
          <div>HBL: {{ quotation.HBL }} <br /></div>
          <div>
            Consignee :
            {{
              quotation.shipment_on_fast
                ? quotation.shipment_on_fast.consignee_name
                : ""
            }}
            <br />
          </div>
          <div>
            GW&CBM : {{ quotation.trong_luong }}
            {{ quotation.so_khoi ? "& " + quotation.so_khoi : "" }}
            <br />
          </div>
          <div>
            Cont&seal :
            {{
              quotation.shipment_on_tms
                ? quotation.shipment_on_tms.container_no
                : ""
            }}
            {{
              quotation.shipment_on_tms
                ? "& " + quotation.shipment_on_tms.seal_no
                : ""
            }}
            <br />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <table class="table">
          <thead>
            <tr>
              <th v-if="quotation.carriers_name ? true : false">Carrier</th>
              <th v-if="quotation.pol ? true : false">POL</th>
              <th v-if="quotation.pod ? true : false">POD</th>
              <th v-if="quotation.fred ? true : false">Freq</th>
              <th v-if="quotation.transit_time ? true : false">Transit time</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td v-if="quotation.carriers_name ? true : false">
                {{ quotation.carriers_name }}
              </td>
              <td v-if="quotation.pol ? true : false">{{ quotation.pol }}</td>
              <td v-if="quotation.pod ? true : false">{{ quotation.pod }}</td>
              <td v-if="quotation.fred ? true : false">{{ quotation.fred }}</td>
              <td v-if="quotation.transit_time ? true : false">
                {{ quotation.transit_time }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="html2pdf__page-break1" />
    <div class="row">
      <div class="col-12 text-center">
        <table
          class="table-print"
          v-if="fee_types != null && unit_types != null"
        >
          <thead>
            <tr>
              <th>Payable Acc</th>
              <th>Description</th>
              <th>Unit</th>
              <th>Unit price</th>
              <th>Quantity</th>
              <th>Amount</th>
              <th>Currency</th>
              <th>EX RATE VND</th>
              <th>EX RATE USD</th>
              <th>Note</th>
            </tr>
          </thead>
          <tbody v-for="(c, idx) in costs" :key="idx">
            <tr v-for="(i, index) in c.detail" :key="index">
              <td>
                {{
                  companyItems.filter((k) => k.id == i.payableAcc)[0]
                    ? companyItems.filter((k) => k.id == i.payableAcc)[0].Acronym
                    : ""
                }}
              </td>
              <td>{{ fee_types.filter((k) => k.id == i.fee_type)[0].text }}</td>
              <td>
                {{
                  unit_types.filter((k) => k.id == i.unit)[0]
                    ? unit_types.filter((k) => k.id == i.unit)[0].text
                    : ""
                }}
              </td>
              <td class="text-right">{{ i.unit_price }}</td>
              <td class="text-right">{{ i.qty }}</td>
              <td colspan="1" class="text-right">
                {{
                  i.currency == "USD"
                    ? FnUSD(
                        i.qty * (i.unit_price + "").replace(/,/g, "") +
                          i.qty *
                            (i.unit_price + "").replace(/,/g, "") *
                            (i.vat ? i.vat / 100 : "0")
                      )
                    : FN(
                        i.qty *
                          (i.unit_price + "")
                            .replace(/\./g, "")
                            .replace(/,/g, "") +
                          i.qty *
                            (i.unit_price + "")
                              .replace(/\./g, "")
                              .replace(/,/g, "") *
                            (i.vat ? i.vat / 100 : "0")
                      )
                }} (VAT: {{ i.vat }}%)
              </td>
              <td class="text-right">{{ i.currency }}</td>
              <!-- Ex rate VND -->
              <td class="text-right">
                {{
                  i.currency == "USD"
                    ? FN(
                       ( (i.qty * (i.unit_price + "").replace(/,/g, "") +
                          i.qty *
                            (i.unit_price + "").replace(/,/g, "") *
                            (i.vat ? i.vat / 100 : "0")) *
                          exchangeRate).toFixed(0)
                      )
                    : FN(
                        i.qty *
                          (i.unit_price + "")
                            .replace(/\./g, "")
                            .replace(/,/g, "") +
                          i.qty *
                            (i.unit_price + "")
                              .replace(/\./g, "")
                              .replace(/,/g, "") *
                            (i.vat ? i.vat / 100 : "0")
                      ) 
                }}
              </td>
              <!-- Ex rate USD -->
              <td class="text-right">
                {{
                  i.currency == "USD"
                    ?
                FnUSD(
                        i.qty * (i.unit_price + "").replace(/,/g, "") +
                          i.qty *
                            (i.unit_price + "").replace(/,/g, "") *
                            (i.vat ? i.vat / 100 : "0")
                      )
                    : 
                    FN(
                        i.qty *
                          (i.unit_price + "")
                            .replace(/\./g, "")
                            .replace(/,/g, "") +
                          i.qty *
                            (i.unit_price + "")
                              .replace(/\./g, "")
                              .replace(/,/g, "") *
                            (i.vat ? i.vat / 100 : "0")
                      )
                    
                   
                }}
              </td>

              <td>{{ i.notes }}</td>
            </tr>
          </tbody>
          <tbody v-for="c in currencies" :key="c.id">
            <tr>
              <td colspan="6"></td>
              <td class="text-center">
                <b><span>Subtotal</span></b>
              </td>
              <td class="text-right">
                <b>{{ FN(getTotalVND(c.id)) }} </b>
              </td>
              <td class="text-right">
                <b>{{ getTotalUSD(c.id) }} </b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-12">
        <div class="mt-1">
          <h6 class="mr-1">IN WORDS:</h6>
          <p class="m-0">U.S DOLLAR(S): {{ Dollar2words(getSumTotalUSD()) }}</p>
          <p>VND: {{ VNnum2words(getSumTotalVND()) }}</p>
        </div>
      </div>

      <b-col cols="8">
        <p>
          BANKING DETAILS: <br />
          ACCOUNT NAME : INTERLOGISTICS JSC. BANK NAME : VIET NAM MARITIME
          COMMERCIAL JOINT STOCK BANK- DO THANH BRANCH <br />
          BANK ADDRESS : 194 XO VIET NGHE TINH, WARD 21, BINH THANH DIST., HO
          CHI MINH CITY, VIET NAM <br />
          SWIFT CODE : MCOBVNVX <br />
          ACCOUNT NO : 047-01-37-1000023 (USD) <br />
          047- 01-01-1000020 (VND)<br />
        </p>
      </b-col>
      <b-col cols="4" class="text-center">
        <p class="pb-5">For and on behalf of WR1 CORP.</p>

        <p class="pt-3">Authorizied signature <span class="ml-1">Date</span></p>
      </b-col>
    </div>
    <b-row align-h="between">
      <b-col cols="4">
        <h5>HO CHI MINH HEAD OFFICE</h5>
        <p>
          1st Floor, Saigon Port Building,<br />
          3 Nguyen Tat Thanh St., Ward 13, Dist. 4,<br />
          Ho Chi Minh City, Vietnam<br />
          Tel: 84-28-3943-5899
        </p>
      </b-col>
      <b-col cols="4">
        <h5>HAI PHONG OFFICE</h5>
        <p>
          Office: 5th Floor, Thanh Dat 1 building,<br />
          No.3 Le Thanh Tong, Ngo Quyen Dist.,<br />
          Hai Phong, VN<br />

          Tel: 84-225-3250-476
        </p>
      </b-col>
    </b-row>
  </div>
</template>
<style>
.table-print td {
  text-align: left;
}
.table-print th {
  text-align: center !important;
}
.table-print td,
.table-print th {
  border-bottom: 1px solid #333 !important;
  border-right: 1px solid #333 !important;
  padding: 4px 6px;
}
.table-print th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #2b938c;
  color: white;
}
</style>
<script>
import moment from "moment";

import {
  BImg,
  BDropdown,
  BDropdownItem,
  BButton,
  BFormTextarea,
  BFormInput,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormDatepicker,
  BRow,
  BCol,
  BTable,
  BCard,
  BCardText,
} from "bootstrap-vue";
import VueHtml2pdf from "vue-html2pdf";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import { default as VNnum2words } from "vn-num2words";
import { default as Dollar2words } from "dollars-to-words";

export default {
  props: {
    cards: {},
    costs: { default: null },
    fee_types: { default: null },
    unit_types: { default: null },
    currencies: { default: null },
    request_quotation: { default: null },
    service_types: { default: null },
    locations: { default: null },
    companyItems: { default: null },
    view_quotation: { default: null },
  },
  components: {
    BImg,
    VueHtml2pdf,
    BDropdown,
    BDropdownItem,
    BButton,
    BFormTextarea,
    BCardText,
    BFormInput,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BRow,
    BCol,
    BTable,
    BCard,
    BCardText,
    FeatherIcon,
  },
  data() {
    return {
      appLogoImage: require("@/assets/images/logo/logo.png"),
      userData: JSON.parse(localStorage.getItem("userData")),
      quotation: {},
      // exchangeRate: 22688,
      VNnum2words,
      Dollar2words,
      moment,
    };
  },
  created() {
    this.$store.dispatch("masterData/fetchRate");
  },
  computed: {
    exchangeRate: function () {
      return this.$store.getters["masterData/exchangeRate"];
    },
  },
  mounted() {
    if (this.request_quotation != null && this.service_types != null) {
      this.quotation = this.request_quotation;
    }
  },
  methods: {
    getTotal(currency) {
      var t = 0;
      this.costs.forEach((c) => {
        c.detail.forEach((i) => {
          if (i.checked && i.currency == currency) {
            t +=
              i.qty * (i.unit_price + "").replace(/,/g, "") +
              i.qty *
                (i.unit_price + "").replace(/,/g, "") *
                (i.vat ? i.vat / 100 : "0");
          }
        });
      });
      return t;
    },
    getSumTotalVND() {
      var a = 0;

      this.costs.forEach((c) => {
        c.detail.forEach((i) => {
          if (i.checked && i.currency == "VND") {
            a +=
              i.qty * (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") +
              i.qty *
                (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                (i.vat ? i.vat / 100 : "0");
          } else {
            a +=
              (i.qty * (i.unit_price + "").replace(/,/g, "") +
                i.qty *
                  (i.unit_price + "").replace(/,/g, "") *
                  (i.vat ? i.vat / 100 : "0")) *
              this.exchangeRate;
          }
        });
      });

      return a.toFixed(0);
    },
    containsKey(obj, key) {
      return Object.keys(obj).includes(key);
    },
    getSumTotalUSD() {
      var a = 0;

      this.costs.forEach((c) => {
        c.detail.forEach((i) => {
          if (i.checked && i.currency == "VND") {
            a +=
              (i.qty *
                (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") +
                (i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                  i.vat) /
                  100) /
              this.exchangeRate;
          } else {
            a +=
              i.qty * (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") +
              i.qty *
                (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                (i.vat ? i.vat / 100 : "0");
          }
        });
      });

      return a;
    },
    getTotalUSD(currency) {
      var t = 0;
      if (currency == "VND") {
        this.costs.forEach((c) => {
          c.detail.forEach((i) => {
            if (i.checked && i.currency == currency) {
              t +=
                (i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") +
                  (i.qty *
                    (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                    i.vat) /
                    100) /
                this.exchangeRate;
            }
          });
        });
        return t.toFixed(2);
      } else {
        this.costs.forEach((c) => {
          c.detail.forEach((i) => {
            if (i.checked && i.currency == currency) {
              t +=
                i.qty * (i.unit_price + "").replace(/,/g, "") +
                i.qty *
                  (i.unit_price + "").replace(/,/g, "") *
                  (i.vat ? i.vat / 100 : "0");
            }
          });
        });
        return this.FnUSD(t.toFixed(2));
      }
    },

    getTotalVND(currency) {
      var t = 0;
      if (currency == "VND") {
        this.costs.forEach((c) => {
          c.detail.forEach((i) => {
            if (i.checked && i.currency == currency) {
              t +=
                i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") +
                i.qty *
                  (i.unit_price + "").replace(/\./g, "").replace(/,/g, "") *
                  (i.vat ? i.vat / 100 : "0");
            }
          });
        });
      } else {
        this.costs.forEach((c) => {
          c.detail.forEach((i) => {
            if (i.checked && i.currency == currency) {
              t +=
                (i.qty * (i.unit_price + "").replace(/,/g, "") +
                  i.qty *
                    (i.unit_price + "").replace(/,/g, "") *
                    (i.vat ? i.vat / 100 : "0")) *
                this.exchangeRate;
            }
          });
        });
      }
      return t;
    },
    FN: function (value) {
      try {
        return (value + "")
          .replace(/[^0-9]/g, "")
          .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
      } catch (err) {
        return value;
      }
    },
    FnUSD: function (value) {
      try {
        return (value + "")
          .replace(/[^0-9 || \\.]/g, "")
          .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      } catch (err) {
        return value;
      }
    },
  },
};
</script>